// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"Items__Wrapper_3pX8A","Inner":"Items__Inner_1Ukrk container grid"};